import { reactive, ref, onMounted, Ref } from '@vue/composition-api';

let state: { firstHeight: number } | null = null;

export default function useWatchKeyboard(): { showFooter: Ref<boolean> } {
  if (!state) {
    state = reactive({
      firstHeight: 0
    });
  }
  const showFooter = ref(true);

  const watchKeyboard = () => {
    const observer = new ResizeObserver((entries: ResizeObserverEntry[]) => {
      for (const entry of entries) {
        if (entry.target === document.body) {
          console.info('entry.contentRect.height', entry.contentRect.height, new Date().getTime());
          if (state) {
            !state.firstHeight && (state.firstHeight = entry.contentRect.height);
            if (entry.contentRect.height < state.firstHeight - 200) {
              showFooter.value = false;
            } else {
              showFooter.value = true;
            }
          }
        }
      }
    });
    observer.observe(document.body);
  };

  onMounted(() => {
    watchKeyboard();
  });

  return { showFooter };
}
